import Vue from "vue";
import Meta from "vue-meta";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "@/router";
import store from "@/store";
import BootstrapVue from "bootstrap-vue";
import plugins from "@/plugins";
import {extend} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import {messages} from "@/lang/vee-validate.json";
import CoreUiVue from "@coreui/vue";
import {iconsSet as icons} from "./assets/icons/icons.js";
import i18n from "@/plugins/i18n";
import moment from "moment";
import VueImg from "v-img";
import {loadVeeValidateExtend} from "./plugins/vee-validate";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import ScrollLoader from 'vue-scroll-loader'

Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use(BootstrapVue);
Vue.use(CoreUiVue);
Vue.use(Meta);
Vue.use(plugins);
Vue.use("DatePicker", DatePicker);
const vueImgConfig = {
  // Use `alt` attribute as gallery slide title
  altAsTitle: false,
  // Display 'download' button near 'close' that opens source image in new tab
  sourceButton: false,
  // Event listener to open gallery will be applied to <img> element
  openOn: "click",
  // Show thumbnails for all groups with more than 1 image
  thumbnails: false
};
Vue.use(VueImg, vueImgConfig);
Vue.use(ScrollLoader)

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messages[rule] // assign message
  });
});
import MainLayout from "@/components/MainLayout.vue";
import GuestLayout from "@/components/GuestLayout.vue";
import ErrorLayout from "@/components/ErrorLayout.vue";

loadVeeValidateExtend();
Vue.component("MainLayout", MainLayout);
Vue.component("GuestLayout", GuestLayout);
Vue.component("ErrorLayout", ErrorLayout);
import Select2 from "v-select2-component";

Vue.component("Select2", Select2);
import VueMask from "v-mask";
import VCalendar from "v-calendar";

Vue.use(VCalendar, {
  componentPrefix: "vc"
});

Vue.use(VueMask);
Vue.filter("formatDate", function (date) {
  if (!date) return "";
  let d = moment(date, "YYYY-MM-DD");
  return d.format("DD/MM/YYYY");
});

Vue.filter("formatDateTime", function (dateTime) {
  let d = moment(dateTime, "YYYY-MM-DD hh:mm:ss");
  return d.format("hh:mm - DD/MM/YYYY");
});

Vue.filter("formatHour", function (date) {
  if (!date) return "";
  let d = moment(date, "hh:mm:ss");
  return d.format("HH:mm");
});
new Vue({
  i18n,
  router,
  store,
  icons,
  ...App
}).$mount("#app");
